import React from "react";
import { SHIPPING_POLICY_CONFIG_URL } from "../../../../api/api_routing_urls";
import showToast from "../../../../utilities/notification/NotificationModal";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import ContainerShadow from "../../../../reusable-components/containers/ContainerShadow";
import useAuth from "../../../../authentication/hooks/useAuth";
import { useForm } from "react-hook-form";
import { button, cancel_button } from "../../../../theme/lightTheme";
import TextArea from "../../../../reusable-components/inputs/InputTextAreas/TextArea";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Button from "../../../../reusable-components/buttons/Button";
import RichTextArea from "../../../../reusable-components/richtexteditor/RichTextArea";

const AddShippingPolicy = ({
  getShippingPolicyDetails,
  shippingPolicy,
  setShippingPolicy,
  setShowAddForm,
}) => {
  // const axiosPrivate = useAxiosPrivate();

  // const { auth } = useAuth();

  const isEdit =
    shippingPolicy !== undefined
      ? Object.keys(shippingPolicy).length > 0
      : false;

  const defaultValues = {
    shipping_policy_content: isEdit
      ? shippingPolicy.shipping_policy_content
      : "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    defaultValues: defaultValues,
  });

  const emptyObj = {};
  const setDefaultValueEmpty = () => {
    setShowAddForm(false);
  };

  const onSubmit = async (data) => {
    try {
      let response = {};
      if (isEdit) {
        data.shipping_policy_id = shippingPolicy.shipping_policy_id;
        // data.updatedby = auth.userid;
        data.updatedby = "admin";
        response = await axios.post(
          `${SHIPPING_POLICY_CONFIG_URL}/update`,
          data
        );
      } else {
        // data.createdby = auth.userid;
        data.createdby = "admin";
        response = await axios.post(SHIPPING_POLICY_CONFIG_URL, data);
      }
      if (response.status === 200) {
        if (isEdit) {
          showToast("Shipping Policy Details Successfully Updated", "success");
        } else {
          showToast("Shipping Policy Details Successfully Added", "success");
        }
        getShippingPolicyDetails();
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
      setDefaultValueEmpty();
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  return (
    <ContainerShadow>
      <form onSubmit={handleSubmit(onSubmit)}>
        <RichTextArea
          defaultName={"shipping_policy_content"}
          register={register}
          name={"Shipping Policy Description"}
          classes={"w-full"}
          clearError={clearErrors}
          setError={setError}
          setValue={setValue}
          data={defaultValues.shipping_policy_content}
          errors={errors}
          pattern={null}
          required={true}
        />
        <div className="flex items-center justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={`${isEdit ? "Update" : "Submit"}`}
            className={button}
          />
          <Button className={cancel_button} onClick={setDefaultValueEmpty}>
            Cancel
          </Button>
        </div>
      </form>
    </ContainerShadow>
  );
};

export default AddShippingPolicy;
